export const homeDesktopItems = [
  { label: "Overview", to: "/overview" },
  { label: "Blogs", to: "/blog" },
  { label: "Get Started", to: "/get-started" },
];

export const homeMobileItems = [
  { label: "Overview", to: "/overview" },
  { label: "Solutions", to: "/solutions" },
  { label: "Blogs", to: "/blog" },
  { label: "Integration", to: "/integration" },
  { label: "Demo", to: "/demo" },
  { label: "Get Started", to: "/get-started", variant: "primary" },
];

export const landingDesktopItems = [
  { label: "Overview", to: "/overview" },
  { label: "Solutions", to: "/solutions" },
  { label: "Integrations", to: "/integration" },
  { label: "Demo's", to: "/demo" },
  { label: "Blogs", to: "/blog" },
  { label: "Get Started", to: "/get-started" },
];

export const landingMobileItems = [
  { label: "Overview", to: "/overview" },
  { label: "Solutions", to: "/solutions" },
  { label: "Integration", to: "/integration" },
  { label: "Demo's", to: "/demo" },
  { label: "Blogs", to: "/blog" },
  { label: "Get Started", to: "/get-started", variant: "primary" },
];
